import React, { Ref, useContext, useEffect, useState } from "react";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetReportsDTO from "../../../models/DTO/IOnGetReportsDTO";
import IGetReportsDTO from "../../../models/DTO/IGetReportsDTO";
import IProcessed_Report from "../../../models/IProcessed_Report";
import OwTable from "../../shared/OwTable/OwTable";
import IOwTableCols from "../../../models/IOwTableCols";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import PaginationBar from "../../shared/PaginationBar/PaginationBar";
import { CreateReportSidebar } from "../CreateReportSidebar/CreateReportSidebar";
import { EditReportSidebar } from "../EditReportSidebar/EditReportSidebar";
import { Link } from "react-router-dom";
import QueueStatusEnum from "../../../models/QueueStatusEnum";
import UserService from "../../../services/UserService";
import * as _ from "lodash-es";
import IProcessReportDTO from "../../../models/DTO/IProcessReportDTO";
import IOnProcessReportDTO from "../../../models/DTO/IOnProcessReportDTO";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IGetCustomReportsDTO from "../../../models/DTO/IGetCustomReportsDTO";
import IOnGetCustomReportsDTO from "../../../models/DTO/IOnGetCustomReportsDTO";
import ICustom_Report from "../../../models/ICustom_Report";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import { ReportsReadyFilter } from "../ReportsReadyFilter/ReportsReadyFilter";
import { ConfirmDeleteOverlayFn } from "../../shared/ConfirmDeleteOverlayFn/ConfirmDeleteOverlayFn";
import { OwDeleteEditActions } from "../../shared/OwDeleteEditActions/OwDeleteEditActions";
import { SearchSection } from "../../shared/SearchSection/SearchSection";
import { useAppContextNonNull } from "@contexts/AppContext";

type Props = {};

export const ReportsReady: React.FC<Props> = (props) => {
    const { userModel, supplierModel, socket, uiContext } = useAppContextNonNull();

    const renderTitle = (row: IProcessed_Report) => {
        if (Number(row.status) === QueueStatusEnum.COMPLETED) {
            return (
                <div>
                    <Link to={`/reports/${row.guid}`}>{row.title.length ? row.title : <OwLabel title={"view"} />}</Link>
                    {uiContext.showHiddenFeatures && (
                        <OwButton
                            className={"ms-2 btn-primary"}
                            fn={() => {
                                console.log(row);
                            }}
                            title={"Log Report Data"}
                        />
                    )}
                </div>
            );
        } else {
            return row.title;
        }
    };

    const renderDate = (dateStr: string) => {
        return UserService.parseLastUpdated(dateStr, true);
    };

    const renderReportType = (row: IProcessed_Report) => {
        const reportType = _.startCase(row.report_type.replace(/_/g, " "));
        const itemName = row.report_options.itemName || "";

        return (
            <div>
                <span>{reportType}</span>
                {itemName.length ? <span className={"ms-4"}>({itemName})</span> : null}
            </div>
        );
    };

    const renderStatus = (row: IProcessed_Report) => {
        return _.startCase((row.Queue_Status?.name || "").toLowerCase().replaceAll("_", " "));
    };

    const toggleConfirmDelete = (row: IProcessed_Report, index: number) => {
        const rowElem = document.getElementById(`row-${index}`);

        setDeleteElemId(`row-${index}`);
        setDeleteElem(rowElem);
        setRowToDelete(row);
    };

    const renderActions = (row: IProcessed_Report, index: number) => {
        return (
            <div>
                <OwDeleteEditActions
                    isEditMode={false}
                    onTrashClickFn={() => {
                        toggleConfirmDelete(row, index);
                    }}
                    onEditClickFn={() => {
                        showEditSidebar(row);
                    }}
                    hideEdit={false}
                />
            </div>
        );
    };

    const getColumns = (): IOwTableCols[] => {
        return [
            {
                title: "",
                valueProp: "",
                renderFn: renderActions,
                renderFnEmitsRow: true,
                isActionsCol: true,
            },
            {
                title: "title",
                valueProp: "title",
                renderFn: renderTitle,
                renderFnEmitsRow: true,
            },
            {
                title: "report_type",
                valueProp: "report_type",
                renderFn: renderReportType,
                renderFnEmitsRow: true,
            },
            {
                title: "status",
                valueProp: "",
                renderFn: renderStatus,
                renderFnEmitsRow: true,
            },
            {
                title: "created_at",
                valueProp: "created_at",
                renderFn: renderDate,
            },
        ];
    };

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(25);
    const [columns, setColumns] = useState(getColumns());
    const [reports, setReports] = useState<IProcessed_Report[]>([]);
    const [totalReports, setTotalReports] = useState(0);
    const [initialData, setInitialData] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [rowToDelete, setRowToDelete] = useState<IProcessed_Report | null>(null);
    const [deleteRef, setDeleteRef] = useState<Ref<HTMLElement> | null>(null);
    const [deleteElem, setDeleteElem] = useState<HTMLElement | null>(null);
    const [customReports, setCustomReports] = useState<ICustom_Report[]>([]);
    const [deleteElemId, setDeleteElemId] = useState<string | null>(null);

    const getCustomReports = () => {
        const payload: IGetCustomReportsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.ReportGetCustomReports, payload);
    };

    const onGetCustomReports = (data: IOnGetCustomReportsDTO) => {
        setCustomReports(data.customReports);
    };

    const reportFinishedProcessing = () => {
        getReports();
    };

    const getReports = (queryString?: string) => {
        const payload: IGetReportsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
            limit,
            offset,
        };

        if (queryString) {
            payload.queryString = queryString;
        }

        socket.emit(EndpointsEnum.ReportGetReports, payload);

        setIsLoading(true);
    };

    const onGetReports = (data: IOnGetReportsDTO) => {
        setReports(data.reports);
        setTotalReports(data.totalReports);
        setInitialData(false);
        setIsLoading(false);
    };

    const onProcessReport = (data: IOnProcessReportDTO) => {
        const notification: INotification = {
            message: "successfully_processed_report",
            position: NotificationPositionEnum.bc,
            level: NotificationLevelEnum.success,
        };

        uiContext.notifyFn(null, notification);

        setRowToDelete(null);
        setDeleteRef(null);
        setDeleteElem(null);

        getReports();
    };

    const sockets: IUiSocketSetup[] = [
        { endpoint: EndpointsEnum.ReportOnGetReports, fn: onGetReports },
        { endpoint: EndpointsEnum.ReportOnProcessReport, fn: onProcessReport },
        { endpoint: EndpointsEnum.ReportFinishedProcessing, fn: reportFinishedProcessing },
        { endpoint: EndpointsEnum.ReportOnGetCustomReports, fn: onGetCustomReports },
    ];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        document.title = `Orderwerks >> Reports`;

        getReports();
        getCustomReports();

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    useEffect(() => {
        setColumns(getColumns());
    }, [uiContext.showHiddenFeatures]);

    const closeSidebar = (refresh?: boolean) => {
        uiContext.toggleSidebar(false);
        uiContext.setSidebarComponent(null);

        if (refresh) {
            getReports();
        }
    };

    const showCreateSidebar = (row?: IProcessed_Report) => {
        const component = (
            <CreateReportSidebar
                close={closeSidebar}
                socket={socket}
                notifyFn={uiContext.notifyFn}
                processedReport={row}
                setActivityIndicator={uiContext.setActivityIndicator}
                customReports={customReports}
            />
        );

        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);
    };

    const showEditSidebar = (row: IProcessed_Report) => {
        const component = (
            <EditReportSidebar
                close={closeSidebar}
                report={row}
                notifyFn={uiContext.notifyFn}
                setActivityIndicator={uiContext.setActivityIndicator}
                userModel={userModel}
                supplierModel={supplierModel}
            />
        );

        uiContext.setSidebarComponent(component);
        uiContext.toggleSidebar(true);
    };

    const onPaginationChanged = (_offset: number, _limit: number) => {
        setOffset(_offset);
        setLimit(_limit);

        getReports();
    };

    const assignOverlayRefFn = (ref: Ref<HTMLElement>) => {
        setDeleteRef(ref);
    };

    const cancelDelete = () => {
        setRowToDelete(null);
        setDeleteRef(null);
        setDeleteElem(null);
        setDeleteElemId(null);
    };

    const commitDelete = () => {
        if (rowToDelete) {
            const payload: IProcessReportDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                deleteFlag: true,
                reportGuid: rowToDelete.guid,
            };

            socket.emit(EndpointsEnum.ReportProcessReport, payload);
        }
    };

    return (
        <div className={"ReportsReady position-relative"}>
            <div className="mt-3 d-flex align-items-center">
                <OwTitle title="Reports" leftIconName="fad fa-chart-bar" />
                <div className={"ms-2"}>
                    <OwButton title={"create"} leftIconClass={"fas fa-plus"} fn={() => showCreateSidebar()} className={"btn-warning"} />
                </div>
            </div>

            <div>
                <div>
                    <SearchSection>
                        <ReportsReadyFilter customReports={customReports} performSearch={getReports} />
                    </SearchSection>
                </div>
                <div className={"text-end"}>
                    <OwLabel title={"total_rows"} postText={":"} className={"me-2"} />
                    {totalReports}
                </div>
                <div className={"position-relative"}>
                    <ConfirmDeleteOverlayFn
                        targetElem={deleteElemId}
                        handleConfirm={commitDelete}
                        handleCancel={cancelDelete}
                        nestedParentElem={"reports-ready"}
                        skipMainView={true}
                    />

                    <OwTable
                        id={"reports-ready"}
                        columns={columns}
                        dataSet={reports}
                        userModel={userModel}
                        supplierModel={supplierModel}
                        dataFetch={isLoading}
                        initialData={initialData}
                    />
                </div>
            </div>
            <div>
                <PaginationBar offset={offset} limit={limit} totalRecords={totalReports} onPaginationChanged={onPaginationChanged} />
            </div>
        </div>
    );
};
